import { SVGProps } from 'react'

import { wrapIllustration } from '../wrap-illustration'

function SvgEmailSuccess(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={160}
      height={160}
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.98 53.134a6 6 0 0 1 3.44-4.692l32.17-14.843a12 12 0 0 1 10.624.282l26.581 14.015a6 6 0 0 1 3.154 6.063l-5.15 40.546a6 6 0 0 1-5.952 5.245H24.871a6 6 0 0 1-5.952-6.756l5.062-39.86Z"
        fill="#42A486"
      />
      <path
        d="m65.843 75.176 30.8-16.328a6.24 6.24 0 0 0 3.284-4.719l1.855-12.167.005-.043c.326-2.56-.985-5.055-3.297-6.273L72.435 21.906a12.86 12.86 0 0 0-11.369-.299l-31.646 14.6a6.248 6.248 0 0 0-3.6 4.875L23.967 53.25A6.253 6.253 0 0 0 27 59.411l26.325 15.49a12.855 12.855 0 0 0 12.518.275Z"
        fill="#00664F"
      />
      <path
        d="M33.643 39.454a2.4 2.4 0 0 1 2.38-2.098H92.09a1.8 1.8 0 0 1 1.786 2.027L88.46 82.027a6 6 0 0 1-5.952 5.244H34.38a6 6 0 0 1-5.952-6.756l5.215-41.061Z"
        fill="#F1F5F9"
      />
      <path
        d="M54.561 69.424a12.855 12.855 0 0 0 12.518.276L91.68 56.658 88.46 82.027a6 6 0 0 1-5.953 5.244H34.38a6 6 0 0 1-5.953-6.756l3.127-24.627 23.007 13.536Z"
        fill="#CCD5E1"
      />
      <path
        d="M24.87 99.75h63.977a6 6 0 0 0 5.952-5.245l5.128-40.375a6.24 6.24 0 0 1-3.284 4.719l-30.8 16.328a12.855 12.855 0 0 1-12.518-.276L27 59.412a6.253 6.253 0 0 1-3.034-6.161L18.92 92.994a6 6 0 0 0 5.952 6.756Z"
        fill="#80CCB5"
      />
      <path
        d="M24.87 99.75h63.977a6 6 0 0 0 5.952-5.245l5.128-40.375a6.24 6.24 0 0 1-3.284 4.719l-30.8 16.328a12.855 12.855 0 0 1-12.518-.276L27 59.412a6.253 6.253 0 0 1-3.034-6.161L18.92 92.994a6 6 0 0 0 5.952 6.756Z"
        fill="#78B441"
      />
      <path
        d="M88.537 99.75H25.24c-3.813 0-6.763-3.29-6.29-7.014l.004-.03a5.198 5.198 0 0 1 2.285-3.64l26.364-17.531 5.72 3.365a12.855 12.855 0 0 0 12.519.276l6.101-3.234 20.267 15.993a6.968 6.968 0 0 1 2.616 6.35 6.188 6.188 0 0 1-.454 1.665c-.973 2.253-3.24 3.8-5.836 3.8Z"
        fill="#599F40"
      />
      <path
        d="M25.241 99.75h63.296c3.197 0 5.894-2.343 6.29-5.466A5.957 5.957 0 0 0 91.94 88.4L65.047 72.578a12 12 0 0 0-11.706-.26L21.339 89.283a4.56 4.56 0 0 0-2.388 3.454c-.473 3.724 2.477 7.013 6.29 7.013Z"
        fill="#78B441"
      />
      <path
        d="M17.744 38.104a.798.798 0 0 1 .98-.563l1.934.52a.799.799 0 1 1-.414 1.544l-1.934-.52a.8.8 0 0 1-.566-.98Zm4.236-8.738a.8.8 0 0 1 1.128.091l2.038 2.391a.8.8 0 1 1-1.218 1.036l-2.037-2.39a.8.8 0 0 1 .09-1.128Zm7.984.835-.103-1.869a.798.798 0 0 1 .755-.841.802.802 0 0 1 .843.755l.104 1.87a.799.799 0 0 1-.756.841.802.802 0 0 1-.843-.756ZM110.455 41.209a.794.794 0 0 0-.822-.771l-2.004.064a.807.807 0 0 0-.781.824c.011.44.379.786.822.772l2.004-.065a.807.807 0 0 0 .781-.824Zm-.845-9.112a.802.802 0 0 0-1.12-.168l-2.545 1.859a.799.799 0 0 0-.177 1.116c.26.355.762.43 1.12.17l2.545-1.86a.798.798 0 0 0 .177-1.117Zm-10.145-.35.541-1.794a.791.791 0 0 0-.537-.99.808.808 0 0 0-.998.54l-.542 1.795a.791.791 0 0 0 .537.99.808.808 0 0 0 .999-.541Z"
        fill="#0F172A"
      />
      <path
        d="M57.136 50.716a3.362 3.362 0 0 0-4.695-.233 3.236 3.236 0 0 0-.237 4.62l6.004 6.539a3.362 3.362 0 0 0 4.695.233 3.236 3.236 0 0 0 .237-4.62l-6.004-6.539Z"
        fill="#78B441"
      />
      <path
        d="M70.062 46.496a3.399 3.399 0 0 1 4.747.236 3.271 3.271 0 0 1-.24 4.672L62.816 61.86a3.399 3.399 0 0 1-4.747-.236 3.271 3.271 0 0 1 .24-4.672l11.753-10.456Z"
        fill="#78B441"
      />
      <path
        d="M58.59 62.08a3.378 3.378 0 0 1-.51-.446 3.192 3.192 0 0 1 .237-4.627l2.52-2.194 2.281 2.433a3.192 3.192 0 0 1-.237 4.627 3.402 3.402 0 0 1-.48.35 3.51 3.51 0 0 1-3.81-.143Z"
        fill="#599F40"
      />
    </svg>
  )
}
export default wrapIllustration(SvgEmailSuccess)
